import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.414,6.414,15.586,3.586A2,2,0,0,0,14.172,3H7A2,2,0,0,0,5,5V19a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V7.828A2,2,0,0,0,18.414,6.414Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.09,17,9.06,14.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13,15.09,11.09,17"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.09,17V11"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19,8H15a1,1,0,0,1-1-1V3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgDownload;
